module.exports = __webpack_public_path__ + "img/751.2382ac68.png";